// src/lib/kinema/konva/overlays/SnapGuides.ts
import Konva from 'konva';
import type { GuideLine } from '../../core/tools/snapCalculation';

export class SnapGuides {
  private lines: Konva.Line[] = [];
  private layer: Konva.Layer;

  constructor(layer: Konva.Layer) {
    this.layer = layer;
  }

  showGuides(guides: GuideLine[], _stageHeight?: number, _stageWidth?: number): void {
    this.clear();
    // Use large extent so guides always fill the visible area
    const extent = 10000;
    for (const guide of guides) {
      const line = new Konva.Line({
        points: guide.orientation === 'vertical'
          ? [guide.position, -extent, guide.position, extent]
          : [-extent, guide.position, extent, guide.position],
        stroke: '#ef4444',
        strokeWidth: 1,
        dash: [4, 4],
        listening: false,
      });
      this.layer.add(line);
      this.lines.push(line);
    }
    this.layer.batchDraw();
  }

  clear(): void {
    for (const line of this.lines) {
      line.destroy();
    }
    this.lines = [];
    this.layer.batchDraw();
  }
}
